import React, { useState, useEffect } from 'react';
import Collapsible from 'react-collapsible';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import './Accordion.scss';


const Accordion = (props) => {

  const getNodes = (nodes) => nodes.filter((child) => !isEmpty(child))
  const [openPosition, setOpenPosition] = useState(props.startPosition);
  const [isOpen, setIsOpen] = useState({ 0: true });
  const [nodes, setNodes] = useState (getNodes(props.children))

  useEffect(() => {
    setNodes(getNodes(props.children))
  }, [props.children]);

  const handleTriggerClick = (position) => {
    if (props.siblingOpen) {
      setIsOpen({ ...isOpen, [position]: !isOpen[position] });
    } else {
      let openedPosition;
      if (position !== openPosition) {
        openedPosition = position;
      }
      setOpenPosition(openedPosition);

      if (props.handleClick) {
        props.handleClick(openedPosition);
      }
    }
  };

  return (<div>
    {nodes.map((node, index) => {
      const triggerWhenOpen = (node.props['data-trigger-when-open']) ?
        node.props['data-trigger-when-open'] : node.props['data-trigger'];
      const triggerDisabled = (node.props['data-trigger-disabled']) || false;
      const className = node.props['data-classname'];

      return (
        <Collapsible
          key={'Collapsible' + index}
          handleTriggerClick={handleTriggerClick}
          open={props.siblingOpen ? isOpen[index] : (openPosition === index)}
          trigger={node.props['data-trigger']}
          triggerWhenOpen={triggerWhenOpen}
          triggerDisabled={triggerDisabled}
          transitionTime={props.transitionTime}
          easing={props.easing}
          classParentString={props.classParentString}
          accordionPosition={index}
          className={className}
          openedClassName={className}
        >
          {node}
        </Collapsible>
      );
    })
    }
  </div>);
};

Accordion.propTypes = {
  transitionTime: PropTypes.number,
  easing: PropTypes.string,
  startPosition: PropTypes.number,
  classParentString: PropTypes.string,
  siblingOpen: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.shape({
    props: PropTypes.shape({
      'data-trigger': PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
      ]).isRequired,
      'data-triggerWhenOpen': PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element,
      ]),
      'data-triggerDisabled': PropTypes.bool,
      'data-classname': PropTypes.string,
    }),
  })),
  handleClick: PropTypes.func,
};

export default Accordion;
